import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../../service/auth/auth.service";
import { CommunityBoard } from "../../../service/board/board";
import { BoardService } from "../../../service/board/board.service";
import { CommonService } from "../../../service/common/common.service";

import { DatePipe } from "@angular/common";
import * as moment from "moment";
import { GtmService } from "../../../service/gtm/gtm.service";
import { ImageUploadService } from "../../../service/image/image.service";
import { PageService } from "../../../service/page/page.service";
import { QuillConfigService } from "../../../service/quill/quill.service";

@Component({
  selector: 'app-community-detail',
  templateUrl: './community-detail.component.html',
  styleUrls: ['./community-detail.component.scss'],
  providers: [BoardService, PageService, DatePipe, QuillConfigService, ImageUploadService]
})
export class CommunityDetailComponent implements OnInit {

  board: CommunityBoard;
  id: number;
  tags: string;
  url: string;

  public updating: boolean = false;
  private hours: string[] = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11',
    '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
  private minutes: string[] = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

  startDate = {
    day: '',
    hour: '',
    minute: '',
  }
  endDate = {
    day: '',
    hour: '',
    minute: '',
  }

  categories: string[];

  constructor(private boardService: BoardService,
    private authService: AuthService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
    private quillService: QuillConfigService,
    private imageService: ImageUploadService,
    private gtmService: GtmService,
    private datePipe: DatePipe) {

    this.url = location.href;

    this.boardService.getCategory().subscribe(
      ({ categories }) => this.categories = categories
    )

    this.route.params.subscribe(params => {
      this.id = params['id'] ? +params['id'] : null;

      if (this.id) {
        this.boardService.getByCommunity(this.id).subscribe(board => {
          this.updating = false;
          this.board = board;

          if (board.location) {
            this.board.location = board.location.key;
            this.board.locationName = board.location.name;
          }
          else this.board.location = '';
          this.tags = this.board.tags.join(' ');
          if (this.board.startDate && this.board.endDate) {
            this.startDate.day = this.board.startDate.substr(0, 10);
            this.startDate.hour = this.board.startDate.substr(11, 2);
            this.startDate.minute = this.board.startDate.substr(14, 2);

            this.endDate.day = this.board.endDate.substr(0, 10);
            this.endDate.hour = this.board.endDate.substr(11, 2);
            this.endDate.minute = this.board.endDate.substr(14, 2);
          }

          if (this.board.url) {
            this.board.url = this.board.url.indexOf('http') == -1 ? `http://${this.board.url}` : this.board.url;
          }


          this.gtmService.pageViewWithPage({
            'path': this.route.snapshot['_routerState'].url,
            'title': board.title,
            'breadcrumb': 'Home > Member > Community'
          });
        });
      } else {
        this.updating = true;
        this.board = new CommunityBoard();
        this.board.location = '';
        this.board.category = '';
        this.board.status = "OPEN";
        this.startDate.day = moment().startOf('month').format('YYYY-MM-DD');
        this.endDate.day = moment().endOf('month').format('YYYY-MM-DD');

        this.gtmService.pageViewWithPage({
          'path': this.route.snapshot['_routerState'].url,
          'title': '글쓰기',
          'breadcrumb': 'Home > Member > Community'
        });
      }
    });
  }

  ngOnInit() {
  }

  onUpdate(board: CommunityBoard, tmp: boolean = false) {
    if (this.id) board.id = this.id;
    if (board.location === '') delete board.location
    else board.location = board.location = { key: board.location }
    board.status = tmp ? "TEMP" : "OPEN";
    if (this.tags) board.tags = this.tags.replace(/[ \{\}\[\]\/?.,;:|\)*~`!^\-_+┼<>@\#$%&\'\"\\(\=]/gi, ' ').split(' ').filter(str => str.trim().length);
    board.startDate = `${this.startDate.day} ${this.startDate.hour}:${this.startDate.minute}:00`;
    board.endDate = `${this.endDate.day} ${this.endDate.hour}:${this.endDate.minute}:00`;

    if (!board.title) {
      window.alert('제목을 입력해 주세요.');
      return;
    } else if (!board.category) {
      window.alert('모임의 종류를 선택해 주세요.');
      return;
    } else if (!board.thumbnail) {
      window.alert('썸네일을 등록해 주세요.');
      return;
    } else if (!this.startDate.day || !this.startDate.hour || !this.startDate.minute) {
      window.alert('시작 일정을 입력해 주세요.');
      return;
    } else if (!this.endDate.day || !this.endDate.hour || !this.endDate.minute) {
      window.alert('종료 일정을 입력해 주세요.');
      return;
    } else if (!board.summary) {
      window.alert('요약을 입력해 주세요.');
      return;
    } else if (!board.content) {
      window.alert('내용을 입력해 주세요.');
      return;
    }

    this.boardService.saveByCommunity(board).subscribe(
      res => {
        this.updating = false;

        if (!board.id) {
          this.gtmService.newPostEvent({
            'title': res.title,
            'list': 'Community',
            'date': this.datePipe.transform(res.createdDate, 'yyyyMMdd'),
            'author': res.author.nick || res.author.name
          });
        }
        window.scrollTo(0, 0);

        this.board = res;
        this.board.content = board.content;
        this.router.navigateByUrl(`/member/community/${res.id}`);
      }
    );
  }
  onDelete() {
    if (window.confirm('삭제 하시겠습니까?')) {
      this.boardService.deleteByBoard(this.id).subscribe(
        board => this.router.navigateByUrl('/member/community')
      );
    }
  }
  onClickUpdate() {
    window.scrollTo(0, 0);
    this.updating = true;
  }
  onClickBack() {
    window.scrollTo(0, 0);
    window.history.back();
  }

  onReport() {
    if (window.confirm('신고하시겠습니까?')) {
      this.boardService.report(this.board.id).subscribe(
        result => {
          window.alert('신고가 접수되었습니다.');
        }
      );
    }
  }

  public editor;
  onEditorCreated(quill) {
    this.editor = quill;

    const toolbar = quill.getModule('toolbar');
    toolbar.addHandler('image', this.imageHandler.bind(this));
  }
  imageHandler() {
    const Imageinput = document.createElement('input');
    Imageinput.setAttribute('type', 'file');
    Imageinput.setAttribute('accept', 'image/png, image/gif, image/jpeg');
    Imageinput.classList.add('ql-image');

    Imageinput.addEventListener('change', () => {
      const file = Imageinput.files;
      this.imageService.makeFileRequest('/api/file-uploads', file).then(
        (result) => {
          this.pushImageToEditor(result['filename']);
        },
      )
    });

    Imageinput.click();
  }
  pasteHandler(imageDataUrl, type, imageData) {
    const file = imageData.toFile('paste.png')
    this.imageService.makeFileRequest('/api/file-uploads', [file]).then(
      (result) => {
        this.pushImageToEditor(result['filename']);
      },
    )
  }
  get pasteImageHandler() {
    return this.pasteHandler.bind(this)
  }
  pushImageToEditor(src) {
    const range = this.editor.getSelection(true);
    const index = range.index + range.length;
    this.editor.insertEmbed(range.index, 'image', src);
  }

  isMine(email: string): boolean {
    return this.authService.getEmail() == email;
  }

  showProfile(email: string) {
    this.commonService.addProfileEvent(email);
  }


  onCanUpdate(): boolean {
    return !this.updating && !!this.board
      && (this.board.author.email == this.authService.getEmail() || this.authService.isAdmin());
  }

  onLike() {
    if (this.board.likeByMe) {
      this.boardService.unlike(this.board.id).subscribe(
        result => {
          this.board.likeByMe = false;
          this.board.countOfLikes--;
          this.initLikeList = false;
        }
      );
    } else {
      this.boardService.like(this.board.id).subscribe(
        result => {
          this.initLikeList = false;
          this.board.likeByMe = true;
          this.board.countOfLikes++;
          this.gtmService.likeEvent({
            'title': this.board.title,
            'list': 'Hey!',
            'date': this.datePipe.transform(this.board.createdDate, 'yyyyMMdd'),
            'author': this.board.author.nick || this.board.author.name
          });
        }
      );
    }
  }

  initLikeList = false;
  showLikeList = false;
  likeList = []
  onLikeView() {
    if (!this.initLikeList) {
      this.boardService.likelist(this.board.id).subscribe(
        result => {
          this.likeList = result;
          this.initLikeList = true;
          this.showLikeList = result.length ? true : false;
        }
      )
    }

    if (this.likeList.length) this.showLikeList = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/member/community-board/community-detail/community-detail.component.ts